import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, TextField, Typography, Grid } from "@material-ui/core";
import { CheckCircle, Cancel, Edit, RateReview } from "@material-ui/icons";

import {
  reviewSelectionCouncil,
  reviewMidtermCouncil,
  reviewFinalCouncil,
} from "../../../../reducer/internalResearch/action";
import { uploadMultiFile } from "../../../../reducer/file/action";
import MultiFileManager from "../../../File/MultiFileManager/MultiFileManager";
import select from "../../../../utils/select";
import SectionCard from "../../utils/SectionCard";
import {
  INT_REVIEW_ACTION_ACCEPT,
  INT_REVIEW_ACTION_REJECT,
  INT_REVIEW_ACTION_ADJUST_REQUEST,
  INT_COUNCIL_TYPE_SELECTION,
  INT_COUNCIL_TYPE_MIDTERM,
  INT_COUNCIL_TYPE_FINAL,
} from "../../../../constants/internalResearchStatus";

const DISPATCH_FN_BY_TYPE = {
  [INT_COUNCIL_TYPE_SELECTION]: reviewSelectionCouncil,
  [INT_COUNCIL_TYPE_MIDTERM]:   reviewMidtermCouncil,
  [INT_COUNCIL_TYPE_FINAL]:     reviewFinalCouncil,
};

const TITLE_BY_TYPE = {
  [INT_COUNCIL_TYPE_SELECTION]: "Kết luận Hội đồng tuyển chọn (HĐ#1)",
  [INT_COUNCIL_TYPE_MIDTERM]:   "Kết luận Hội đồng tiến độ (HĐ#2)",
  [INT_COUNCIL_TYPE_FINAL]:     "Kết luận Hội đồng nghiệm thu (HĐ#3)",
};

// CouncilReviewForm — admin nhập kết quả 1 hội đồng (accept/adjust/reject) +
// 2 file: Biên bản + Phiếu đánh giá. Dùng cho cả 3 vòng hội đồng.
export default function CouncilReviewForm({ detail, councilType, onDone }) {
  const dispatch = useDispatch();
  const profileDetail = useSelector((s) => select(s, "profileReducer", "detail"));

  const [comment, setComment] = useState("");
  const [pending, setPending] = useState(null);
  const [minutesUrls, setMinutesUrls] = useState([]);
  const [minutesNewFiles, setMinutesNewFiles] = useState([]);
  const [evalUrls, setEvalUrls] = useState([]);
  const [evalNewFiles, setEvalNewFiles] = useState([]);

  const commitFiles = async (existingUrls, newFiles, setUrls, setNewFiles) => {
    if (!newFiles || newFiles.length === 0) return existingUrls.join("||");
    const ownerId = profileDetail?.id || 0;
    const result = await dispatch(uploadMultiFile(ownerId, newFiles, "internalResearch"));
    if (result?.success && Array.isArray(result.data)) {
      const merged = [...existingUrls, ...result.data];
      setUrls(merged);
      setNewFiles([]);
      return merged.join("||");
    }
    return existingUrls.join("||");
  };

  const handle = async (action) => {
    if (
      (action === INT_REVIEW_ACTION_ADJUST_REQUEST || action === INT_REVIEW_ACTION_REJECT) &&
      !comment.trim()
    ) {
      alert("Vui lòng nhập nhận xét / lý do.");
      return;
    }
    setPending(action);
    try {
      const minutesFileLink    = await commitFiles(minutesUrls, minutesNewFiles, setMinutesUrls, setMinutesNewFiles);
      const evaluationFileLink = await commitFiles(evalUrls,    evalNewFiles,    setEvalUrls,    setEvalNewFiles);
      const fn = DISPATCH_FN_BY_TYPE[councilType];
      const ok = await dispatch(fn(detail.id, { action, comment, minutesFileLink, evaluationFileLink }));
      if (ok && onDone) onDone();
    } finally {
      setPending(null);
    }
  };

  return (
    <Box padding="16px 24px">
      <SectionCard icon={<RateReview />} title={TITLE_BY_TYPE[councilType] || "Kết luận hội đồng"} marginTop={0}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              <b>Biên bản hội đồng</b>
            </Typography>
            <MultiFileManager
              fileUrls={minutesUrls}
              setFileUrls={setMinutesUrls}
              newFiles={minutesNewFiles}
              setNewFiles={setMinutesNewFiles}
              disabled={pending !== null}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" style={{ marginBottom: 6 }}>
              <b>Phiếu đánh giá</b>
            </Typography>
            <MultiFileManager
              fileUrls={evalUrls}
              setFileUrls={setEvalUrls}
              newFiles={evalNewFiles}
              setNewFiles={setEvalNewFiles}
              disabled={pending !== null}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth multiline minRows={4} variant="outlined"
              label="Nhận xét / lý do"
              placeholder="Bắt buộc khi Yêu cầu chỉnh sửa hoặc Loại"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
            />
          </Grid>
        </Grid>
      </SectionCard>

      <Box marginTop={3} paddingTop={2} display="flex" gridGap={12} justifyContent="flex-end" borderTop="solid 1px #e0e0e0">
        <Button
          variant="contained"
          style={{ backgroundColor: "#b52f2f", color: "#fff" }}
          startIcon={<Cancel />} disabled={pending !== null}
          onClick={() => handle(INT_REVIEW_ACTION_REJECT)}
        >
          Loại
        </Button>
        <Button
          variant="outlined" color="secondary"
          startIcon={<Edit />} disabled={pending !== null}
          onClick={() => handle(INT_REVIEW_ACTION_ADJUST_REQUEST)}
        >
          Yêu cầu chỉnh sửa
        </Button>
        <Button
          variant="contained" color="primary"
          startIcon={<CheckCircle />} disabled={pending !== null}
          onClick={() => handle(INT_REVIEW_ACTION_ACCEPT)}
        >
          Duyệt
        </Button>
      </Box>
    </Box>
  );
}
